import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#09090b]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Back Link */}
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-400 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" />
          Tilbage til forsiden
        </Link>

        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 rounded-xl bg-[#DFFF00]/10 flex items-center justify-center">
            <Shield className="h-6 w-6 text-[#DFFF00]" />
          </div>
          <div>
            <h1 style={{ fontFamily: 'Oswald, sans-serif' }} className="text-3xl font-bold text-white uppercase tracking-tight">
              Privatlivspolitik
            </h1>
            <p className="text-sm text-zinc-500">Sidst opdateret: 1. marts 2025</p>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-invert prose-zinc max-w-none">
          <div className="bg-[#18181b] border border-white/5 rounded-xl p-6 sm:p-8 space-y-8">
            
            <section>
              <h2 className="text-xl font-bold text-white mb-4">1. Dataansvarlig</h2>
              <p className="text-zinc-400 leading-relaxed">
                <span className="text-[#DFFF00]">[FIRMANAVN]</span> er dataansvarlig for behandlingen af de personoplysninger, 
                vi indsamler om dig. Du kan kontakte os på:
              </p>
              <div className="mt-4 p-4 bg-zinc-900/50 rounded-lg">
                <p className="text-zinc-400"><span className="text-[#DFFF00]">[FIRMANAVN]</span></p>
                <p className="text-zinc-400"><span className="text-[#DFFF00]">[ADRESSE]</span></p>
                <p className="text-zinc-400">CVR: <span className="text-[#DFFF00]">[CVR-NUMMER]</span></p>
                <p className="text-zinc-400">Email: <span className="text-[#DFFF00]">[EMAIL]</span></p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">2. Hvilke Oplysninger Indsamler Vi</h2>
              <p className="text-zinc-400 leading-relaxed mb-4">
                Vi indsamler følgende kategorier af personoplysninger:
              </p>
              
              <h3 className="text-lg font-semibold text-white mt-6 mb-3">Kontooplysninger</h3>
              <ul className="list-disc list-inside text-zinc-400 space-y-2">
                <li>Navn og email-adresse</li>
                <li>Adgangskode (krypteret)</li>
                <li>Profilbillede (valgfrit)</li>
              </ul>

              <h3 className="text-lg font-semibold text-white mt-6 mb-3">Fitness- og Sundhedsdata</h3>
              <ul className="list-disc list-inside text-zinc-400 space-y-2">
                <li>Vægt, højde og alder</li>
                <li>Træningsmål og erfaringsniveau</li>
                <li>Træningshistorik og aktivitetsdata</li>
                <li>Søvndata og vandindtag</li>
                <li>Kropsmålinger</li>
              </ul>

              <h3 className="text-lg font-semibold text-white mt-6 mb-3">Betalingsoplysninger</h3>
              <ul className="list-disc list-inside text-zinc-400 space-y-2">
                <li>Betalingshistorik</li>
                <li>Abonnementsstatus</li>
                <li>Kortoplysninger behandles af Stripe og gemmes ikke hos os</li>
              </ul>

              <h3 className="text-lg font-semibold text-white mt-6 mb-3">Tekniske Data</h3>
              <ul className="list-disc list-inside text-zinc-400 space-y-2">
                <li>IP-adresse</li>
                <li>Browsertype og enhedsoplysninger</li>
                <li>Brugsstatistik og logfiler</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">3. Formål med Behandlingen</h2>
              <p className="text-zinc-400 leading-relaxed mb-4">Vi behandler dine oplysninger til følgende formål:</p>
              <ul className="list-disc list-inside text-zinc-400 space-y-2">
                <li>Levering af vores tjeneste (træningsprogrammer, madplaner, tracking)</li>
                <li>Personalisering af AI-genereret indhold</li>
                <li>Administration af dit abonnement og betalinger</li>
                <li>Kommunikation om din konto og tjenesten</li>
                <li>Forbedring og udvikling af vores platform</li>
                <li>Overholdelse af lovmæssige forpligtelser</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">4. Retsgrundlag</h2>
              <p className="text-zinc-400 leading-relaxed">
                Vi behandler dine personoplysninger på følgende retsgrundlag i henhold til GDPR:
              </p>
              <ul className="list-disc list-inside text-zinc-400 mt-4 space-y-2">
                <li><strong className="text-white">Kontrakt (art. 6.1.b):</strong> Behandling nødvendig for at levere vores tjeneste</li>
                <li><strong className="text-white">Samtykke (art. 6.1.a):</strong> For sundhedsrelaterede data og markedsføring</li>
                <li><strong className="text-white">Legitim interesse (art. 6.1.f):</strong> Forbedring af tjenesten og sikkerhed</li>
                <li><strong className="text-white">Retlig forpligtelse (art. 6.1.c):</strong> Bogføring og skattelovgivning</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">5. Deling af Oplysninger</h2>
              <p className="text-zinc-400 leading-relaxed mb-4">
                Vi deler dine oplysninger med følgende kategorier af modtagere:
              </p>
              <ul className="list-disc list-inside text-zinc-400 space-y-2">
                <li><strong className="text-white">Stripe:</strong> Betalingsbehandling (USA, EU-US Data Privacy Framework)</li>
                <li><strong className="text-white">MongoDB:</strong> Database hosting (EU)</li>
                <li><strong className="text-white">Anthropic:</strong> AI-tjenester til generering af planer (USA)</li>
              </ul>
              <p className="text-zinc-400 leading-relaxed mt-4">
                Vi sælger aldrig dine personoplysninger til tredjeparter.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">6. Opbevaringsperiode</h2>
              <p className="text-zinc-400 leading-relaxed">
                Vi opbevarer dine personoplysninger så længe du har en aktiv konto hos os. 
                Ved sletning af din konto vil vi slette eller anonymisere dine data inden for 30 dage, 
                medmindre vi er forpligtet til at opbevare dem længere af lovmæssige årsager (f.eks. bogføringslovens 5 år).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">7. Dine Rettigheder</h2>
              <p className="text-zinc-400 leading-relaxed mb-4">
                I henhold til GDPR har du følgende rettigheder:
              </p>
              <ul className="list-disc list-inside text-zinc-400 space-y-2">
                <li><strong className="text-white">Ret til indsigt:</strong> Du kan få en kopi af dine personoplysninger</li>
                <li><strong className="text-white">Ret til berigtigelse:</strong> Du kan få rettet ukorrekte oplysninger</li>
                <li><strong className="text-white">Ret til sletning:</strong> Du kan anmode om sletning af dine data</li>
                <li><strong className="text-white">Ret til begrænsning:</strong> Du kan begrænse behandlingen i visse tilfælde</li>
                <li><strong className="text-white">Ret til dataportabilitet:</strong> Du kan få dine data i et struktureret format</li>
                <li><strong className="text-white">Ret til indsigelse:</strong> Du kan gøre indsigelse mod visse behandlinger</li>
                <li><strong className="text-white">Ret til at trække samtykke tilbage:</strong> Hvor behandling er baseret på samtykke</li>
              </ul>
              <p className="text-zinc-400 leading-relaxed mt-4">
                For at udøve dine rettigheder, kontakt os på <span className="text-[#DFFF00]">[EMAIL]</span>.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">8. Sikkerhed</h2>
              <p className="text-zinc-400 leading-relaxed">
                Vi anvender passende tekniske og organisatoriske sikkerhedsforanstaltninger for at beskytte dine personoplysninger, herunder:
              </p>
              <ul className="list-disc list-inside text-zinc-400 mt-4 space-y-2">
                <li>Kryptering af data under overførsel (HTTPS/TLS)</li>
                <li>Krypterede adgangskoder (bcrypt hashing)</li>
                <li>Adgangskontrol og autentificering</li>
                <li>Regelmæssige sikkerhedsopdateringer</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">9. Klage</h2>
              <p className="text-zinc-400 leading-relaxed">
                Hvis du er utilfreds med vores behandling af dine personoplysninger, har du ret til at indgive en klage til:
              </p>
              <div className="mt-4 p-4 bg-zinc-900/50 rounded-lg">
                <p className="text-white font-semibold">Datatilsynet</p>
                <p className="text-zinc-400">Carl Jacobsens Vej 35</p>
                <p className="text-zinc-400">2500 Valby</p>
                <p className="text-zinc-400">Email: dt@datatilsynet.dk</p>
                <p className="text-zinc-400">Tlf: 33 19 32 00</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">10. Ændringer</h2>
              <p className="text-zinc-400 leading-relaxed">
                Vi forbeholder os retten til at opdatere denne privatlivspolitik. Ved væsentlige ændringer vil du blive informeret 
                via email eller en meddelelse på platformen.
              </p>
            </section>

          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-8 pt-8 border-t border-white/5 flex flex-wrap gap-4 text-sm text-zinc-500">
          <Link to="/terms" className="hover:text-[#DFFF00] transition-colors">Vilkår & Betingelser</Link>
          <span>•</span>
          <Link to="/cookies" className="hover:text-[#DFFF00] transition-colors">Cookie-politik</Link>
          <span>•</span>
          <Link to="/handelsbetingelser" className="hover:text-[#DFFF00] transition-colors">Handelsbetingelser</Link>
        </div>
      </div>
    </div>
  );
}
